import '../Content/Images/content/Apple-Pay.jpg';
import '../Content/Images/content/cds-and-iras.jpg';
import '../Content/Images/content/checking-account.jpg';
import '../Content/Images/content/choose-a-checking-account.jpg';
import '../Content/Images/content/Credit-Card.png';
import '../Content/Images/content/financial-freedom.jpg';
import '../Content/Images/content/flexible-banking.jpg';
import '../Content/Images/content/home-content-1.png';
import '../Content/Images/content/home-content-2.jpg';
import '../Content/Images/content/home-content-6.jpg';
import '../Content/Images/content/home-slide-1.jpg';
import '../Content/Images/content/home-slide-2.jpg';
import '../Content/Images/content/Lake-Pleasant-And-Happy-Valley-Exterior.jpg';
import '../Content/Images/content/login-image.jpg';
import '../Content/Images/content/make-savings-a-priority.jpg';
import '../Content/Images/content/MFB-Debit-Card.svg';
import '../Content/Images/content/piggy-bank-and-phone.png';
import '../Content/Images/content/PinPoint-Ad.png';
import '../Content/Images/content/placeholder.png';
import '../Content/Images/content/power-of-interest.jpg';
import '../Content/Images/content/Remote-Deposit-Business.jpg';
import '../Content/Images/content/save-hero.jpg';
import '../Content/Images/content/save-investing.jpg';
import '../Content/Images/content/savings-goals.jpg';
import '../Content/Images/content/savings-simplified.jpg';
import '../Content/Images/content/switch-kit.jpg';
import '../Content/Styles/fonts.scss';
import '../Content/Styles/app.scss';

import common from './app/routes/common';
import login from './app/routes/login';
import nav from './app/routes/nav';
import sectionNav from './app/routes/sectionNav';
import Router from './app/utils/Router';

const routes = new Router({
	common,
	nav,
	sectionNav,
	login,
});

// Load Events
routes.loadEvents();
